module.exports = __webpack_public_path__ + "static/img/monthbook_render.85692ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v5/monthbook_render.png
// module id = lJbp
// module chunks = 0